<ng-container *transloco="let t">
  <p class="pb-2 fs-18 fw-medium">{{t('policy.cookie.subtitle')}} {{environment.cookie_validity_date | localizedDate:'dd.MM.yyyy'}}</p>
  <p>{{t('policy.cookie.intro.1')}} <a href="">{{environment.appName}}</a>  {{t('policy.cookie.intro.2')}}</p>

  <div class="chapter mt-3">
    <p class="fw-medium fs-28">
      {{t('policy.cookie.chapter.1.title')}}
    </p>
    <p>{{t('policy.cookie.chapter.1')}}
    </p>
  </div>

  <div class="chapter mt-3">
    <p class="fw-medium fs-28">
      {{t('policy.cookie.chapter.2.title')}}
    </p>
      <ul>
        <li><p> {{t('policy.cookie.chapter.2.1')}}</p>
          <ul><li>{{t('policy.cookie.chapter.2.2')}}</li><li>{{t('policy.cookie.chapter.2.3')}}</li></ul></li>
        <li><p> {{t('policy.cookie.chapter.2.4')}}</p>
          <ul><li>{{t('policy.cookie.chapter.2.5')}}</li><li>{{t('policy.cookie.chapter.2.6')}}</li></ul></li>
        <li><p> {{t('policy.cookie.chapter.2.7')}}</p>
          <ul><li>{{t('policy.cookie.chapter.2.8')}}</li><li>{{t('policy.cookie.chapter.2.9')}}</li></ul></li>
        <li><p> {{t('policy.cookie.chapter.2.10')}}</p>
          <ul><li>{{t('policy.cookie.chapter.2.11')}}</li><li>{{t('policy.cookie.chapter.2.12')}}</li></ul></li>
      </ul>
  </div>

  <div class="chapter mt-3">
    <p class="fw-medium fs-28">
      {{t('policy.cookie.chapter.3.title')}}
    </p>
    <p>{{t('policy.cookie.chapter.3.1')}}
    </p>
    <ul><li> <p>{{t('policy.cookie.chapter.3.2')}}
    </p></li><li> <p>{{t('policy.cookie.chapter.3.3')}}
    </p></li><li> <p>{{t('policy.cookie.chapter.3.4')}}
    </p></li><li> <p>{{t('policy.cookie.chapter.3.5')}}
    </p></li></ul>
  </div>

  <div class="chapter mt-3">
    <p class="fw-medium fs-28">
      {{t('policy.cookie.chapter.4.title')}}
    </p>
    <p>{{t('policy.cookie.chapter.4')}}
    </p>
  </div>

  <div class="chapter mt-3">
    <p class="fw-medium fs-28">
      {{t('policy.cookie.chapter.5.title')}}
    </p>
    <p>{{t('policy.cookie.chapter.5.1')}}
    </p>
    <ul>
      <li><p><span class="fw-medium">{{t('policy.cookie.chapter.5.2') + " "}}</span>{{t('policy.cookie.chapter.5.3')}}</p></li>
      <li><p><span class="fw-medium">{{t('policy.cookie.chapter.5.4') + " "}}</span>{{t('policy.cookie.chapter.5.5')}}</p></li>
    </ul>
  </div>

  <div class="chapter mt-3">
    <p class="fw-medium fs-28">
      {{t('policy.cookie.chapter.6.title')}}
    </p>
    <p>{{t('policy.cookie.chapter.6')}}
    </p>
  </div>

  <div class="chapter mt-3">
    <p class="fw-medium fs-28">
      {{t('policy.cookie.chapter.7.title')}}
    </p>
    <p>{{t('policy.cookie.chapter.7')}} <a href="mailto: {{environment.contactMail}}">
      {{environment.contactMail}}</a>
    </p>
  </div>

</ng-container>
